export default {
  //厂商MAC
  getCompanyMac: {
    method: 'get',
    url: 'mac-company/list',
    permission: {
      name: "获取厂商MAC列表",
      page: "oemMac",
    }
  },
  addCompanyMac: {
    method: 'post',
    url: 'mac-company/add',
    permission: {
      name: "添加厂商MAC",
      page: "oemMac",
    }
  },
  deleteCompanyMac: {
    method: 'post',
    url: 'mac-company/del',
    permission: {
      name: "删除厂商MAC",
      page: "oemMac",
    }
  },
  //厂商型号
  getModelList: {
    method: 'get',
    url: 'device-model/list',
    permission: {
      name: "获取厂商型号列表",
      page: "oemModel",
    }
  },
  addModel: {
    method: 'post',
    url: 'device-model/add',
    permission: {
      name: "添加厂商型号",
      page: "oemModel",
    }
  },
  reviseModel: {
    method: 'post',
    url: 'device-model/mod',
    permission: {
      name: "修改厂商型号",
      page: "oemModel",
    }
  },
  deleteModel: {
    method: 'post',
    url: 'device-model/del',
    permission: {
      name: "删除厂商型号",
      page: "oemModel",
    }
  },
  //厂商列表
  getCompanyList: {
    method: 'get',
    url: 'company/list',
    permission: {
      name: "获取厂商列表",
      page: "oemCompany",
    }
  },
  addCompany: {
    method: 'post',
    url: 'company/add',
    permission: {
      name: "添加厂商",
      page: "oemCompany",
    }
  },
  reviseCompany: {
    method: 'post',
    url: 'company/mod',
    permission: {
      name: "修改厂商",
      page: "oemCompany",
    }
  },
  deleteCompany: {
    method: 'post',
    url: 'company/del',
    permission: {
      name: "删除厂商",
      page: "oemCompany",
    }
  },
}
